import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { SweetAlertPosition, SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})


export class AlertService {


  constructor() { }


  SuccessAlert(_title: string, _message: string, _position: SweetAlertPosition = 'center', _type: SweetAlertIcon = 'info', _confirmButtonText: string = 'Aceptar') {
    Swal.fire({
      title: _title,
      text: _message,
      icon: _type,
      position: _position,
      confirmButtonText: _confirmButtonText,
      backdrop: true,
    });
  }


  SimpleErrorAlert(_title: string, _message: string, _position: SweetAlertPosition = 'center', _type: SweetAlertIcon = 'error', _confirmButtonText: string = 'Aceptar') {
    Swal.fire({
      title: _title,
      text: _message,
      icon: _type,
      position: _position,
      confirmButtonText: _confirmButtonText,
    });
  }

  Toast(_timer: number, _message: string, _position: SweetAlertPosition = 'center', _type: SweetAlertIcon = 'info') {

    const toast = Swal.mixin({
      toast: true,
      position: _position,
      showConfirmButton: false,
      timer: _timer,
    })
    toast.fire({
      text: _message,
      icon: _type,
    });
  }

  ErrorOnComunicateToApi(_error: any) {
    let JOINED_ERROR =
      _error?.Error?.Message ||
      _error?.error?.Error?.Message ||
      _error?.error ||
      _error;

    if (typeof JOINED_ERROR !== 'string') {
      JOINED_ERROR = JSON.stringify(JOINED_ERROR);
    }

    this.SimpleErrorAlert('Error','A ocurrido un errror de comunicación con el servidor. ' + JOINED_ERROR, 'center', 'error', 'Aceptar');

  }





}
